import { useCallback, useContext } from 'react';
import _get from 'lodash/get';
import dayjs from 'dayjs';
import _find from 'lodash/find';
import { AjaxContext, AppContext, UserContext } from 'commons-ui';
import { UserDetailsContext } from 'context/userDetails';
import { GAME_NAMES, GAME_NAME_LABLES } from 'pages/constants';
import { USER_PROFILE_RESOURCES, PAGE_NAMES, ACTION } from 'constant';

const useService = (transactionAllDetails: any) => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);
	const { permissionsConfig } = useContext(UserContext);
	const {
		transactionId,
		transactionType,
		tournamentId,
		cgrId,
		status,
		transactionTimestamp,
		amount,
		deposit,
		winnings,
		bonus,
		extras,
		type,
		message,
		cashback,
		gstAmount,
		pgAmount
	} = transactionAllDetails;
	const getTransactionDetails = () => ({
		transactionId,
		transactionType,
		tournamentId,
		cgrId,
		status,
		transactionTimestamp,
		transactionAmount: amount,
		bonus,
		winnings,
		deposit,
		couponsUsed: extras.couponCode,
		couponId: extras?.couponId || extras?.cid,
		originalTid: extras?.originalTid,
		gameName: _get(GAME_NAME_LABLES, extras?.gameName || GAME_NAMES.LUDO),
		matchName: extras?.gameName === GAME_NAMES.ZUPEE11 && extras?.labels?.length > 0 ? extras.labels[0] : null,
		type,
		message,
		cashback,
		depositTxnId: extras?.depositTxnId,
		gstTransactionId: extras?.gstTransactionId,
		gstAmount,
		pgAmount
	});

	const getPaymentStatus = useCallback(async (merchant, orderId) => {
		const permission = _find(permissionsConfig, { actionName: ACTION.getPaymentStatus });
		const result = await postData({
			endpoint: `/dashboard/getPaymentStatus/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.transactionHistory}-getPaymentStatus`,
			queryParams: {
				appName
			},
			body: { uid, merchant, orderId },
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});

		return _get(result, ['data', 'data']);
	}, []);

	const getPaymentDetails = async () => {
		const { merchant, orderId, paymentMode } = extras;

		if (merchant && orderId) {
			const data = await getPaymentStatus(merchant, orderId);
			const {
				hookTimestamp,
				clearanceAmount,
				orderAmount,
				merchant: { status: paymentStatus },
				transactionTimestamp: paymentTransactionTimestamp
			} = data;

			return {
				paymentGateway: merchant,
				paymentGatewayTransactionId: orderId,
				paymentMethod: paymentMode,
				paymentTransactionTimestamp: dayjs(new Date(paymentTransactionTimestamp)).format('DD-MM-YYYY hh:mm A'),
				hookTimestamp: dayjs(new Date(hookTimestamp)).format('DD-MM-YYYY hh:mm A'),
				clearanceAmount,
				orderAmount,
				paymentStatus
			};
		}

		return {
			paymentGateway: merchant,
			paymentGatewayTransactionId: orderId,
			paymentMethod: paymentMode
		};
	};

	return {
		getTransactionDetails,
		getPaymentDetails
	};
};

export default useService;
